function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Account from 'modules/Account';
import Hcp from 'modules/Hcp';
import Patient from 'modules/Patient';
import Chevron from 'svg/chevron-right.svg';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import styles from './DaysSelectorControlBtn.pcss';
var _React_PureComponent;
class DaysSelectorControlBtn extends (_React_PureComponent = React.PureComponent) {
    onSetAgpMonthSelectorPage(page) {
        const { setAgpMonthSelectorPage, patient, phiSet, phiSetDocumentId } = this.props;
        setAgpMonthSelectorPage(page, patient, phiSet, phiSetDocumentId, this.prepareAgpPreviewSuccessAction);
    }
    get prepareAgpPreviewSuccessAction() {
        const { activeProfileType } = this.props;
        const successAction = activeProfileType === Account.constants.PROFILE_TYPES.HCP ? Hcp.actions.setReadings : Patient.actions.setReadings;
        return successAction;
    }
    get signProps() {
        const { agpMonthSelectorPage, dgpSelectorlPages } = this.props;
        if (dgpSelectorlPages === 1 || dgpSelectorlPages === 0) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                }
            };
        }
        if (agpMonthSelectorPage <= 0) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign),
                    onClick: ()=>this.onSetAgpMonthSelectorPage(agpMonthSelectorPage + 1)
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                }
            };
        }
        if (agpMonthSelectorPage >= dgpSelectorlPages - 1) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign),
                    onClick: ()=>this.onSetAgpMonthSelectorPage(agpMonthSelectorPage - 1)
                }
            };
        }
        return {
            plusSignProps: {
                className: cn(styles.daysSelectorScrollBtn__sign),
                onClick: ()=>this.onSetAgpMonthSelectorPage(agpMonthSelectorPage + 1)
            },
            minusSignProps: {
                className: cn(styles.daysSelectorScrollBtn__sign),
                onClick: ()=>this.onSetAgpMonthSelectorPage(agpMonthSelectorPage - 1)
            }
        };
    }
    render() {
        const { plusSignProps, minusSignProps } = this.signProps;
        const { date } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.root,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.daysSelectorScrollBtn,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.daysSelectorScrollBtn__signs,
                    children: [
                        /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
                            type: "button"
                        }, minusSignProps), {
                            children: /*#__PURE__*/ _jsx(Chevron, {
                                className: cn(styles['daysSelectorScrollBtn__signIcon--backwards'])
                            })
                        })),
                        /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
                            type: "button"
                        }, plusSignProps), {
                            children: /*#__PURE__*/ _jsx(Chevron, {})
                        })),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.daysSelectorMonth,
                            children: date
                        })
                    ]
                })
            })
        });
    }
}
_define_property(DaysSelectorControlBtn, "propTypes", {
    // Explicit props
    date: PropTypes.string,
    patient: PropTypes.object,
    phiSet: PropTypes.object,
    phiSetDocumentId: PropTypes.string,
    // Implicit props
    agpMonthSelectorPage: PropTypes.number,
    dgpSelectorlPages: PropTypes.number,
    activeProfileType: Account.shapes.profileType,
    // Implicit actions
    setDaysSelectorZoom: PropTypes.func,
    setAgpMonthSelectorPage: PropTypes.func
});
const mapStateToProps = (state)=>({
        activeProfileType: Account.selectors.activeProfileType(state),
        agpMonthSelectorPage: selectors.agpMonthSelectorPage(state),
        dgpSelectorlPages: selectors.dgpSelectorlPages(state)
    });
const mapDispatchToProps = (dispatch)=>({
        setAgpMonthSelectorPage: (page, patient, phiSet, phiSetDocumentId, successAction)=>dispatch(actions.setAgpMonthSelectorPage(page, patient, phiSet, phiSetDocumentId, successAction))
    });
const ConnectedDaysSelectorControlBtn = connect(mapStateToProps, mapDispatchToProps)(DaysSelectorControlBtn);
export default withStyles(styles)(ConnectedDaysSelectorControlBtn);
